module.exports = __webpack_public_path__ + "img/logo-circle.e202eb00.png";